<template>
  <div>
    <!-- Trigger button -->
    <b-button variant="primary" @click="showModal = true">
      <b-icon-plus class="mr-1" /> Add Dashboard
    </b-button>

    <!-- Modal -->
    <b-modal
      id="add-dashboard-modal"
      v-model="showModal"
      title="New Custom Dashboard"
      @shown="focusInput"
      @hidden="resetForm"
      ok-title="Create"
      @ok="httpPost"
      :ok-disabled="processing || !form.name.trim()"
      :ok-variant="'primary'"
    >
      <b-form @submit.stop.prevent="submit">
        <b-form-group label="Dashboard Name" label-for="dashboard-name">
          <b-form-input
            id="dashboard-name"
            v-model.trim="form.name"
            ref="nameInput"
            required
            placeholder="e.g. My Custom Dashboard"
          />
        </b-form-group>
      </b-form>

      <!-- Custom footer so we can show a spinner -->
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()" :disabled="processing">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()" :disabled="processing || !form.name.trim()">
          <b-spinner small v-if="processing" class="mr-1" />
          Create
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import DashboardEventBus from '@/xvisor/bus/DashboardEventBus';

export default {
  data() {
    return {
      showModal: false,
      form: {
        name: '',
      },
      processing: false,
    };
  },
  methods: {
    focusInput() {
      // Auto‑focus when the modal opens
      this.$nextTick(() => {
        const input = this.$refs.nameInput;
        if (input) {
          input.focus();
        }
      });
    },
    resetForm() {
      // Clear state when the modal is hidden
      this.form.name = '';
      this.processing = false;
    },
    httpPost() {
      if (!this.form.name.trim()) return;
      this.processing = true;
      this.$http.post('/dashboards/add', {
        name: this.form.name.trim(),
      }).then(() => {
        this.$bvToast.toast('Successfully added dashboard', { variant: 'success' });
        DashboardEventBus.$emit('added');
      }).catch((e) => {
        this.$bvToast.toast('Failed to add dashboard', { variant: 'danger' });
      }).finally(() => {
        this.processing = false;
      });
    },
  },
};
</script>
